<nav *ngIf="!page?.defaultPage" class="flex my-4 min-h-[40px]" aria-label="Breadcrumb">
    <ol role="list" class="flex items-center space-x-4">
        <li>
            <div>
                <a
                    href="#"
                    title="Home"
                    class="hover:text-gray-500"
                    [ngClass]="{
                        'text-gray-900': !(job || page)?.darkMode,
                        'text-white': (job || page)?.darkMode
                    }">
                    <svg class="h-5 w-5 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path
                            fill-rule="evenodd"
                            d="M9.293 2.293a1 1 0 011.414 0l7 7A1 1 0 0117 11h-1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-3a1 1 0 00-1-1H9a1 1 0 00-1 1v3a1 1 0 01-1 1H5a1 1 0 01-1-1v-6H3a1 1 0 01-.707-1.707l7-7z"
                            clip-rule="evenodd" />
                    </svg>
                    <span [routerLink]="['/']" class="sr-only" i18n>Home</span>
                </a>
            </div>
        </li>
        <li *ngIf="job">
            <div class="flex items-center">
                <svg
                    class="h-5 w-5 flex-shrink-0"
                    [ngClass]="{
                        'text-gray-900': !(job || page)?.darkMode,
                        'text-white': (job || page)?.darkMode
                    }"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true">
                    <path
                        fill-rule="evenodd"
                        d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
                        clip-rule="evenodd" />
                </svg>
                <a
                    [title]="job.category | titlecase"
                    [routerLink]="['/', (component.jobsPage || 'jobs')]"
                    class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                    i18n
                    >Jobs</a
                >
            </div>
        </li>
        <li *ngIf="job?.category && component.showCategory">
            <div class="flex items-center">
                <svg
                    class="h-5 w-5 flex-shrink-0"
                    [ngClass]="{
                        'text-gray-900': !(job || page)?.darkMode,
                        'text-white': (job || page)?.darkMode
                    }"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true">
                    <path
                        fill-rule="evenodd"
                        d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
                        clip-rule="evenodd" />
                </svg>
                <a
                    [title]="job.category | titlecase"
                    [routerLink]="['/', (component.jobsPage || 'jobs'), 'category', job.categorySlug]"
                    class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                    >{{ job.category | titlecase }}</a
                >
            </div>
        </li>
        <li *ngIf="job?.businessUnit && component.showBusinessUnit">
            <div class="flex items-center">
                <svg
                    class="h-5 w-5 flex-shrink-0"
                    [ngClass]="{
                        'text-gray-900': !(job || page)?.darkMode,
                        'text-white': (job || page)?.darkMode
                    }"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true">
                    <path
                        fill-rule="evenodd"
                        d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
                        clip-rule="evenodd" />
                </svg>
                <a
                    [title]="job.businessUnit | titlecase"
                    [routerLink]="['/' + component.jobsUrl]"
                    [queryParams]="{ businessUnit: job.businessUnit }"
                    class="ml-4 text-sm font-medium hover:text-gray-700"
                    [ngClass]="{
                        'text-gray-900': !(job || page)?.darkMode,
                        'text-white': (job || page)?.darkMode
                    }"
                    >{{ job.businessUnit | titlecase }}</a
                >
            </div>
        </li>
        <li *ngIf="!page?.defaultPage">
            <div class="flex items-center">
                <svg
                    class="h-5 w-5 flex-shrink-0"
                    [ngClass]="{
                        'text-gray-900': !(job || page)?.darkMode,
                        'text-white': (job || page)?.darkMode
                    }"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true">
                    <path
                        fill-rule="evenodd"
                        d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
                        clip-rule="evenodd" />
                </svg>
                <a
                    [title]="job?.title || page?.title"
                    href="#"
                    class="ml-4 text-sm font-medium hover:text-gray-700"
                    aria-current="page"
                    [ngClass]="{
                        'text-gray-900': !(job || page)?.darkMode,
                        'text-white': (job || page)?.darkMode
                    }"
                    >
                    <span class="sm:inline hidden">{{ (job?.title || page?.title) | truncate:15 }}</span>
                    <span class="sm:hidden inline">{{ (job?.title || page?.title) }}</span>
                    </a>
            </div>
        </li>
    </ol>
</nav>
